export default {"src":"/_next/static/media/missing-image-icon.a03e8cf2.svg","height":35,"width":40,"blurWidth":0,"blurHeight":0};